module.exports = __webpack_public_path__ + "static/media/icon_benefit_coffee.1954d2c9.svg";